﻿import "../Styles/product-list.css";

(function($) {

    'use strict';

    if (typeof ori != "object") return;

    var self = null,
        $pageContainer,
        SHOPPING_BAG_PAGE = '#shopping-bag-page',
        TABLE_BODY = ".js-products-list",
        PRODUCT_ACTION_SELECTOR = '.product-actions',
        INFO_COL_SIZE = '.col-size-info',
        INFO_COL_PADDING = 5,

        expandedItemsStorageKey,
        expandedItems = {},
        ROW_TOGGLER = "row-toggler",
        ROW_TOGGLE_TRIGGER = "row-toggle-trigger",
        COLLAPSE_SELECTOR = "[data-" + ROW_TOGGLE_TRIGGER + ']',
        CLASS_ARROW_CLOSED = 'v-icon-arrow-right-thin',
        CLASS_ARROW_OPENED = 'v-icon-arrow-down-thin',
        CLASS_OPENED = "opened",
        EXPANDABLE_ARROW = '.icon-expand',
        GROUP_BORDER = ".group-border",
        HIDDEN_CLASS = "hidden";

    ori.addModule("productList", {
        init: function(options) {
            self.setOptions(options);

            if (!self.options.pageSelector || self.options.pageSelector == "") {
                self.options.pageSelector = SHOPPING_BAG_PAGE;
            }

            registerHandlers();
            attachTooltips();

            self.fixSizeOfProductTable();
            expandedItems = self.fetchExpandedItems();
            self.updateExpandedInDom();
        },
        addToExpandedList: function(value) {
            var key = $("[data-row-toggler="+value+"]").closest(TABLE_BODY).attr("id");
            if (key in expandedItems) {
                if (expandedItems[key].indexOf(value) < 0)
                    expandedItems[key].push(value);
            } else {
                expandedItems[key] = [value];
            }
            self.updateExpandedInDom(key);
        },
        fixSizeOfProductTable: function() {
            var productActionsMax = 0,
                $context = getPageContainer();
            $context.find(PRODUCT_ACTION_SELECTOR).each(function() {
                if ($(this).width() > productActionsMax) {
                    productActionsMax = $(this).width();
                }
            });
            self.info("Width of product list flags column updated.");
        },
        fetchExpandedItems: function() {
            var itemList = window.localStorage.getItem(expandedItemsStorageKey);

            if (itemList) {
                try {
                    var parsedList = JSON.parse(itemList);
                    return parsedList;
                }
                catch (e) {}
            }

            return {};
        },
        updateExpandedInDom: function(key) {
            if (typeof key != "undefined") {
                updateExpandedItems(key);
                expandItems(key);
            } else {
                $.each(expandedItems, function(key, value) {
                    if (Array.isArray(value)) {
                        updateExpandedItems(key);
                        expandItems(key);
                    }
                });
            }
            persistExpandedItems();
        },
        initToggling: function($context, storageKey) {
            if (typeof storageKey == "undefined") {
                self.warning("Provide storage key to allow saving toggle status of expandable product list items.");
            }
            expandedItemsStorageKey = storageKey;
            $context.on(self.eventString("click"), COLLAPSE_SELECTOR, function(e) {
                e.preventDefault();
                var $trigger = $(this),
                    key = $trigger.closest(TABLE_BODY).attr("id");
                if (!expandedItems[key]) {
                    expandedItems[key] = [];
                }
                toggleItemRow($trigger, key);
            });
        }
    });

    function getPageContainer() {
        if (!$pageContainer) {
            $pageContainer = $(self.options.pageSelector);
        }
        return $pageContainer;
    }

    function attachTooltips() {
        var $context = getPageContainer();
        $context.find(".js-tooltip").each(function() {
            kendo.applyTooltip($(this));
        });
    }

    function registerHandlers() {
        var $context = getPageContainer();

        self.initToggling($context);

        // recalculate flag column width
        $(window).on(self.eventString("resize"), function() {
            self.fixSizeOfProductTable();
        });
    }

    function hideAllItems($selector) {
        var $triggers = $selector.find("[data-" + ROW_TOGGLE_TRIGGER + "]"),
            $arrows = getTriggerArrows($triggers),
            $togglers = $selector.find("[data-" + ROW_TOGGLER + "]");
        toggleSingleItem($arrows, $togglers, false);
    }

    function getTriggerArrows($triggers) {
        var $arrows = $triggers.map(function() {
            var $trigger = $(this);
            return $trigger.is(EXPANDABLE_ARROW) ? $trigger : $trigger.find(EXPANDABLE_ARROW);
        });
        // need to return a single jQuery object, not array of jQuery objects
        return $($arrows).map(function() {
            return this.toArray();
        });
    }

    function expandItems(key) {
        var $selector = $("#" + key);
        if ($selector.length == 0) {
            return;
        }
        var $trigger,
            $toggler,
            $arrow,
            i;
        hideAllItems($selector);
        for (i = 0; i < expandedItems[key].length; i++) {
            $trigger = $selector.find("[data-" + ROW_TOGGLE_TRIGGER + "=" + expandedItems[key][i] + "]");
            $arrow = getTriggerArrows($trigger),
            $toggler = $selector.find("[data-" + ROW_TOGGLER + "=" + expandedItems[key][i] + "]");
            toggleSingleItem($arrow, $toggler, true);
        }
    }

    function toggleItemRow($trigger, key) {
        var lineNumber = $trigger.data(ROW_TOGGLE_TRIGGER),
            $row = $("#" + key).find("[data-"+ ROW_TOGGLER +"=" + lineNumber + "]"),
            $arrow = getTriggerArrows($trigger),
            expandItem = !$row.is(":visible");

        if (expandItem) {
            expandedItems[key].push(lineNumber);
        } else {
            expandedItems[key] = expandedItems[key].filter(function(value) {
                return value !== lineNumber;
            });
        }

        toggleSingleItem($arrow, $row, expandItem);
        persistExpandedItems();
    }

    function toggleSingleItem($arrow, $item, expand) {
        $arrow.toggleClass(CLASS_ARROW_CLOSED, !expand)
              .toggleClass(CLASS_ARROW_OPENED, !!expand);
        $item.toggleClass(HIDDEN_CLASS, !expand);
        expand ? $item.closest(GROUP_BORDER).addClass(CLASS_OPENED) : $item.closest(GROUP_BORDER).removeClass(CLASS_OPENED);
    }

    function persistExpandedItems() {
        if (typeof expandedItemsStorageKey != "undefined") {
            window.localStorage.setItem(expandedItemsStorageKey, JSON.stringify(expandedItems));
        }
    }

    function checkSelectorInDom(selector) {
        return (document.querySelector("[data-row-toggle-trigger=" + selector + "]") != null);
    }

    function updateExpandedItems(key) {
        expandedItems[key] = expandedItems[key].filter(function(val) {
            return checkSelectorInDom(val);
        });
    }

    self = ori.productList;

})(jQuery);